var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetricsModalicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0A5F59",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0A5F59",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.156 38.676a3.84 3.84 0 0 0-.052 1.158h-4.376c-1.417 0-2.488-.42-3.204-1.137-.717-.717-1.137-1.788-1.137-3.205v-6.983c0-1.418.42-2.489 1.137-3.205.716-.716 1.787-1.137 3.204-1.137h6.984c1.417 0 2.488.42 3.204 1.137.717.716 1.137 1.787 1.137 3.205v5.426a3.948 3.948 0 0 0-.226-.044l-.002-.001h-.001l-.103-.215-.002-.003c-.518-1.055-1.417-1.755-2.499-1.755-1.081 0-1.98.7-2.498 1.753v.002l-.11.219c-1.129.19-2.029.837-2.358 1.836l-.002.006c-.319 1.008.03 2.06.837 2.877l.003.002.064.064Z",
    stroke: "#0A5F59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.735 34.672c.224-.452.43-.503.485-.503.056 0 .26.05.485.503l.266.54.002.003c.11.222.29.408.472.543.181.135.408.25.646.293l.007.001.356.058h.001c.455.077.568.251.589.317.021.067.028.276-.295.604h-.001l-.332.332c-.189.19-.31.439-.375.673a1.634 1.634 0 0 0-.035.759l.041.199.002.009c.14.616-.015.788-.038.805-.02.015-.224.112-.755-.21l-.239-.148-.006-.004a1.557 1.557 0 0 0-.791-.202c-.26 0-.548.057-.79.202l-.007.004-.239.148c-.536.322-.74.224-.758.21-.021-.015-.176-.187-.035-.805l.002-.01.041-.198c.054-.25.03-.521-.035-.755a1.546 1.546 0 0 0-.376-.677l-.33-.331c-.326-.333-.318-.542-.297-.608.02-.063.131-.237.589-.314l.357-.058h.004a1.56 1.56 0 0 0 .654-.295c.182-.137.358-.322.467-.541l.002-.003.266-.54v-.001Z",
    stroke: "#0A5F59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.662 28.598a.625.625 0 0 1 .111.877l-1.928 2.488a1.468 1.468 0 0 1-2.048.248l-.004-.003-1.522-1.198a.212.212 0 0 0-.297.039l-1.983 2.574a.625.625 0 0 1-.99-.763l1.984-2.575a1.462 1.462 0 0 1 2.052-.263l.004.004 1.522 1.197a.218.218 0 0 0 .3-.034l1.922-2.48a.625.625 0 0 1 .877-.111Z",
    fill: "#0A5F59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsModalicon);
export default __webpack_public_path__ + "static/media/MetricsModalicon.78846935af63c783fb867cc143a9f8a6.svg";
export { ForwardRef as ReactComponent };